window.addEventListener("DOMContentLoaded", (event) => {
  let parg = document.querySelectorAll('.h-block__content__parg');
  let pargP = document.querySelectorAll('.h-block__content__parg > p:first-of-type');
  var butt = document.querySelectorAll('.h-block__content__butt');
  parg.forEach((item, i) => {
    let pargH = item.clientHeight;
    if(document.documentElement.clientWidth < 750){
      item.classList.add('max-h-mob');
      let pargH = item.clientHeight;
      let pargPH = item.scrollHeight;
      if (pargH >= pargPH){
        butt[i].classList.add('d-none');
      } else {
        butt[i].classList.remove('d-none');
      }
    } else {
      butt[i].classList.add('d-none');
      item.classList.remove('max-h-mob');
      item.classList.add('max-h-100');
    }
    butt[i].addEventListener('click', event => {
      butt[i].classList.add('d-none');
      item.classList.toggle('max-h-mob');
      item.classList.toggle('max-h-100');
    });
  });
});